import { text } from '@pdfme/schemas';

const numberSchema = {
  pdf: text.pdf,
  ui: text.ui,
  propPanel: {
    ...text.propPanel,
    defaultSchema: {
      ...text.propPanel.defaultSchema,
      type: 'number',
    },
  },
};

export default numberSchema;
